const SvgComponent = props => (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
        <path
            fill={props.fill ? props.fill : '#1F2937'}
            d="M17.656 6.88a6.87 6.87 0 0 0-2.455-3.125h1.674a.625.625 0 1 0 0-1.25H8.75a6.884 6.884 0 0 0-6.853 6.329A2.5 2.5 0 0 0 0 11.25a.625.625 0 0 0 1.25 0 1.25 1.25 0 0 1 .67-1.107 6.85 6.85 0 0 0 1.674 3.78l.981 2.747a1.25 1.25 0 0 0 1.178.83h.994a1.25 1.25 0 0 0 1.177-.83l.15-.42h4.477l.15.42a1.25 1.25 0 0 0 1.177.83h.994a1.25 1.25 0 0 0 1.177-.83l1.267-3.545h.184a1.875 1.875 0 0 0 1.875-1.875v-2.5a1.875 1.875 0 0 0-1.719-1.87Zm-5.781-1.255H8.75a.625.625 0 0 1 0-1.25h3.125a.625.625 0 1 1 0 1.25ZM14.063 10a.937.937 0 1 1 0-1.875.937.937 0 0 1 0 1.875Z"
        />
    </svg>
)
export default SvgComponent
